interface IFeatureToggleServerSideOptions {
  featureCallback?: (context: any, params?: any) => Promise<any>,
  featureName: string,
  featureCallbackParams?: {
    [key: string]: any,
  },
  defaultCallback?: (context: any, params?: any) => Promise<any>,
  defaultCallbackParams?: {
    [key: string]: any,
  },
}
const featureToggleServerSide = async (context: any, {
  featureCallback,
  featureName,
  featureCallbackParams,
  defaultCallback,
  defaultCallbackParams,
}: IFeatureToggleServerSideOptions) => {
  const isFeatureEnabled = context.globalProps.featuresConfig[featureName].isEnabled;
  if (isFeatureEnabled) {
    if (!featureCallback) {
      return null;
    }
    return featureCallback(context, featureCallbackParams);
  }
  if (defaultCallback) {
    return defaultCallback(context, defaultCallbackParams);
  }
  return null;
};

export default featureToggleServerSide;
